(function($){
var $ = jQuery = $;

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Icons ================*/
theme.icons = {
  check: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>',
  chevronRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>',
  arrowLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',
  slideshowPrevArrow: '<button class="slick-prev"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>',
  slideshowNextArrow: '<button class="slick-next"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>'
};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantMedia = variant.featured_media || {};
      var currentVariantMedia = this.currentVariant.featured_media || {};

      if (!variant.featured_media || variantMedia.id === currentVariantMedia.id) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      var hasChanged = false;
      if (
        variant.price !== this.currentVariant.price
        || variant.compare_at_price !== this.currentVariant.compare_at_price
        || variant.unit_price_measurement !== this.currentVariant.unit_price_measurement
        || (
          variant.unit_price_measurement && (
            variant.unit_price !== this.currentVariant.unit_price
            || variant.unit_price_measurement.reference_value !== this.currentVariant.unit_price_measurement.reference_value
            || variant.unit_price_measurement.reference_unit !== this.currentVariant.unit_price_measurement.reference_unit
          )
        )
      ) {
        hasChanged = true;
      }

      if(!hasChanged) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*=============== Components ===============*/
// Loading third party scripts, with callbacks
theme.scriptsLoaded = {};
theme.loadScriptOnce = function(src, callback, beforeRun) {
  if(typeof theme.scriptsLoaded[src] === 'undefined') {
    theme.scriptsLoaded[src] = [];
    var tag = document.createElement('script');
    tag.src = src;

    if(beforeRun) {
      tag.async = false;
      beforeRun();
    }

    if(typeof callback === 'function') {
      theme.scriptsLoaded[src].push(callback);
      if (tag.readyState) { // IE, incl. IE9
        tag.onreadystatechange = (function() {
          if (tag.readyState == "loaded" || tag.readyState == "complete") {
            tag.onreadystatechange = null;
            for(var i = 0; i < theme.scriptsLoaded[this].length; i++) {
              theme.scriptsLoaded[this][i]();
            }
            theme.scriptsLoaded[this] = true;
          }
        }).bind(src);
      } else {
        tag.onload = (function() { // Other browsers
          for(var i = 0; i < theme.scriptsLoaded[this].length; i++) {
            theme.scriptsLoaded[this][i]();
          }
          theme.scriptsLoaded[this] = true;
        }).bind(src);
      }
    }

    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    return true;
  } else if(typeof theme.scriptsLoaded[src] === 'object' && typeof callback === 'function') {
    theme.scriptsLoaded[src].push(callback);
  } else {
    if(typeof callback === 'function') {
      callback();
    }
    return false;
  }
}

theme.loadStyleOnce = function(src) {
  var srcWithoutProtocol = src.replace(/^https?:/, '');
  if(!document.querySelector('link[href="' + encodeURI(srcWithoutProtocol) + '"]')) {
    var tag = document.createElement('link');
    tag.href = srcWithoutProtocol;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    var firstTag = document.getElementsByTagName('link')[0];
    firstTag.parentNode.insertBefore(tag, firstTag);
  }
}

theme.addNoticeToForm = function($notice, $form) {
  var $existingNotices = $('.ajax-add-notice', $form);
  if($existingNotices.length > 0) {
    setTimeout(function(){ // wait until fading-out has definitely finished
      $existingNotices.replaceWith($notice.addClass('ajax-add-notice--pre-replace'));
      setTimeout(function(){
        $notice.removeClass('ajax-add-notice--pre-replace');
      }, 10);
    }, 251);
  } else {
    $notice.addClass('ajax-add-notice--pre-reveal').appendTo($form).slideDown(250, function(){
      $(this).removeClass('ajax-add-notice--pre-reveal');
    });
  }
};

$(document).on('submit', 'form.product-form[data-ajax-add="true"]', function(e) {
  var $form = $(this);
  // Disable add button
  $form.find(':submit').attr('disabled', 'disabled').each(function(){
    var contentFunc = $(this).is('button') ? 'html' : 'val';
    $(this).data('previous-value', $(this)[contentFunc]())[contentFunc](theme.strings.addingToCart);
  });

  // Hide any notices
  $('.ajax-add-notice', $form).css('opacity', 0);

  // Add to cart
  $.post(theme.routes.cart_add_url, $form.serialize(), function(itemData) {

    // Enable add button
    var $btn = $form.find(':submit').each(function(){
      var $btn = $(this);
      var contentFunc = $(this).is('button') ? 'html' : 'val';
      // Revert to normal
      $btn.removeAttr('disabled')[contentFunc]($btn.data('previous-value'));
    }).first();


    // reload header
    $.get(theme.routes.search_url , function(data){
      var selectors = [
        '.page-header .cart'
      ];
      var $parsed = $($.parseHTML('<div>' + data + '</div>'));
      for(var i=0; i<selectors.length; i++) {
        var cartSummarySelector = selectors[i];
        var $newCartObj = $parsed.find(cartSummarySelector).clone();
        var $currCart = $(cartSummarySelector);
        $currCart.replaceWith($newCartObj);
      }
    });

    // display added notice
    var $template = $([
      '<div class="ajax-add-notice ajax-add-notice--added global-border-radius">',
        '<div class="ajax-add-notice__inner">',
          '<div class="ajax-add-notice__item">',
            '<span class="feather-icon">', theme.icons.check, '</span>',
            theme.strings.addedToCart,
          '</div>',
          '<div class="ajax-add-notice__go">',
            '<a href="', theme.routes.cart_url, '">',
              theme.strings.goToCart,
              '<span class="feather-icon feather-icon--small">', theme.icons.chevronRight, '</span>',
            '</a>',
          '</div>',
        '</div>',
      '</div>'
    ].join(''));

    theme.addNoticeToForm($template, $form);

  }, 'json').fail(function(data) {
    // Enable add button
    var $firstBtn = $form.find(':submit').removeAttr('disabled').each(function(){
      var $btn = $(this);
      var contentFunc = $btn.is('button') ? 'html' : 'val';
      $btn[contentFunc]($btn.data('previous-value'))
    }).first();

    // Not added, show message
    if(typeof(data) != 'undefined' && data.responseJSON && data.responseJSON.description) {
      var $template = $([
        '<div class="ajax-add-notice ajax-add-notice--error global-border-radius">',
          '<div class="ajax-add-notice__inner">',
            data.responseJSON.description,
          '</div>',
        '</div>'
      ].join(''));
      theme.addNoticeToForm($template, $form);
    } else {
      // Some unknown error? Disable ajax and submit the old-fashioned way.
      $form.attr('data-ajax-add', false);
      $form.submit();
    }
  });
  return false;
});

theme.Disclosure = (function() {
  var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  function Disclosure($disclosure) {
    this.$container = $disclosure;
    this.cache = {};
    this._cacheSelectors();
    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
  }

  Disclosure.prototype = $.extend({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        $disclosureList: this.$container.find(selectors.disclosureList),
        $disclosureToggle: this.$container.find(selectors.disclosureToggle),
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions)
      };
    },

    _connectToggle: function() {
      this.cache.$disclosureToggle.on(
        'click',
        function(evt) {
          var ariaExpanded =
            $(evt.currentTarget).attr('aria-expanded') === 'true';
          $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);
        }.bind(this)
      );
    },

    _connectOptions: function() {
      this.cache.$disclosureOptions.on(
        'click',
        function(evt) {
          evt.preventDefault();
          this._submitForm($(evt.currentTarget).data('value'));
        }.bind(this)
      );
    },

    _onFocusOut: function() {
      this.cache.$disclosureToggle.on(
        'focusout',
        function(evt) {
          var disclosureLostFocus =
            this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.cache.$disclosureList.on(
        'focusout',
        function(evt) {
          var childInFocus =
            $(evt.currentTarget).has(evt.relatedTarget).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !childInFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.$container.on(
        'keyup',
        function(evt) {
          if (evt.which !== 27) return; // escape
          this._hideList();
          this.cache.$disclosureToggle.focus();
        }.bind(this)
      );

      $('body').on(
        'click',
        function(evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this)
      );
    },

    _submitForm: function(value) {
      this.cache.$disclosureInput.val(value);
      this.$container.parents('form').submit();
    },

    _hideList: function() {
      this.cache.$disclosureList.removeClass(classes.listVisible);
      this.cache.$disclosureToggle.attr('aria-expanded', false);
    },

    unload: function() {
      this.cache.$disclosureOptions.off();
      this.cache.$disclosureToggle.off();
      this.cache.$disclosureList.off();
      this.$container.off();
    }
  });

  return Disclosure;
})();

/* Product Media
 *
 * Load and destroy:
 * theme.ProductMedia.init(galleryContainer, {
 *   onModelViewerPlay: function(e){
 *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', false);
 *   },
 *   onModelViewerPause: function(e){
 *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', true);
 *   },
 *   onPlyrPlay: function(e){
 *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', false);
 *   },
 *   onPlyrPause: function(e){
 *     $(e.target).closest('.slick-slider').slick('slickSetOption', 'swipe', true);
 *   },
 * });
 *
 * theme.ProductMedia.destroy(galleryContainer);
 *
 * Trigger mediaVisible and mediaHidden events based on UI
 * $slickSlideshow.on('afterChange', function(evt, slick, current){
 *   $('.product-media--activated').removeClass('product-media--activated').trigger('mediaHidden');
 *   $('.product-media', slick.$slides[current]).addClass('product-media--activated').trigger('mediaVisible');
 * });
 */
theme.ProductMedia = new function(){
  var _ = this;

  _._setupShopifyXr = function() {
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', _._setupShopifyXr.bind(this));
      return;
    }
    document.removeEventListener('shopify_xr_initialized', _._setupShopifyXr);

    window.ShopifyXR.addModels(JSON.parse($(this).html()));
    window.ShopifyXR.setupXRElements();
  };

  this.init = function(container, settings){
    var settings = settings || {},
        _container = container;

    /// First, set up events/callbacks

    // when any media appears
    $(container).on('mediaVisible', '.product-media--video-loaded, .product-media--model-loaded', function(){
      // autoplay all media on larger screens
      if($(window).width() >= 768) {
        $(this).data('player').play();
      }
      // update view-in-space
      if($(this).hasClass('product-media--model')) {
        $('.view-in-space', _container).attr('data-shopify-model3d-id', $(this).data('model-id'));
      }
    });

    // when any media is hidden
    $(container).on('mediaHidden', '.product-media--video-loaded, .product-media--model-loaded', function(){
      // pause all media
      $(this).data('player').pause();
    });

    // necessary callbacks
    if(settings.onVideoVisible) {
      $(container).on('mediaVisible', '.product-media--video-loaded', settings.onVideoVisible);
    }

    if(settings.onVideoHidden) {
      $(container).on('mediaHidden', '.product-media--video-loaded', settings.onVideoHidden);
    }

    $('model-viewer', container).each(function(){
      if(settings.onModelViewerPlay) {
        $(this).on('shopify_model_viewer_ui_toggle_play', settings.onModelViewerPlay);
      }
      if(settings.onModelViewerPause) {
        $(this).on('shopify_model_viewer_ui_toggle_pause', settings.onModelViewerPause);
      }
    });

    /// Second, initialise media

    var $firstMedia = $(container).find('.product-media:first');
    var _autoplayOnceIfRequested = function($currentMedia) {
      return $firstMedia[0] == $currentMedia[0] && settings.autoplayFirstMedia;
    }

    // set up video media elements with a controller
    $(container).find('.product-media--video').each(function(index){
      var enableLooping = $(this).data('enable-video-looping'),
          element = $(this).find('iframe, video')[0],
          $currentMedia = $(this);
      if (element.tagName === 'VIDEO') {
        // set up a controller for Plyr video
        window.Shopify.loadFeatures([
          {
            name: 'video-ui',
            version: '1.0',
            onLoad: (function(){
              var playerObj = { playerType: 'html5', element: element };

              playerObj.play = (function(){
                this.plyr.play();
              }).bind(playerObj);

              playerObj.pause = (function(){
                this.plyr.pause();
              }).bind(playerObj);

              playerObj.destroy = (function(){
                this.plyr.destroy();
              }).bind(playerObj);

              playerObj.plyr = new Shopify.Plyr(element, {
                controls: [
                  'play',
                  'progress',
                  'mute',
                  'volume',
                  'play-large',
                  'fullscreen'
                ],
                autoplay: _autoplayOnceIfRequested($currentMedia),
                loop: { active: enableLooping },
                hideControlsOnPause: true,
                iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
                tooltips: { controls: false, seek: true }
              });
              $(this).data('player', playerObj).addClass('product-media--video-loaded');

               // callbacks for Plyr playback
               $(element).on('playing', function(){
                // pause other media
                $('.product-media').not($currentMedia).trigger('mediaHidden');
                // prevent bubbling inputs that can be used by carousels
                $currentMedia.find('.plyr__controls').off('.themeMediaEventFix')
                  .on('keydown.themeMediaEventFix touchstart.themeMediaEventFix mousedown.themeMediaEventFix', function(e){
                  e.stopPropagation();
                });
                if(callbacks.onPlyrPlay) {
                  callbacks.onPlyrPlay(playerObj);
                }
              });
              $(element).on('pause ended', function(){
                // remove event bubbling interceptor
                $currentMedia.find('.plyr__controls').off('.themeMediaEventFix');
                if(callbacks.onPlyrPause) {
                  callbacks.onPlyrPause(playerObj);
                }
              });
              if(settings.onPlyrInit) {
                settings.onPlyrInit(playerObj);
              }
            }).bind(this)
          }
        ]);
        theme.loadStyleOnce('https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css');

      } else if (element.tagName === 'IFRAME') {
        if (
          /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
            element.src
          )
        ) {
          // set up a controller for YouTube video
          var existingYTCB = window.onYouTubeIframeAPIReady;
          var loadYoutubeVideo = (function() {
            var playerObj = { playerType: 'youtube', element: element };
            var videoId = $(this).data('video-id');

            playerObj.player = new YT.Player(element, {
              videoId: videoId,
              playerVars: {
                autoplay: _autoplayOnceIfRequested($currentMedia) ? 1 : 0,
                origin: window.location.origin
              },
              events: {
                onReady: function(event) {
                  if(_autoplayOnceIfRequested($currentMedia)) {
                    event.target.playVideo();
                  }
                },
                onStateChange: function(event) {
                  if(event.data === YT.PlayerState.ENDED && enableLooping) {
                    event.target.seekTo(0);
                  }
                }
              }
            });

            playerObj.play = (function(){
              try {
                this.player.playVideo();
              } catch(ex) {}
            }).bind(playerObj);

            playerObj.pause = (function(){
              try {
                this.player.pauseVideo();
              } catch (ex) {}
            }).bind(playerObj);

            playerObj.destroy = (function(){
              try {
                // ytapi removes iframe, so restore manually
                var frameHtml = $(this.element)[0].outerHTML,
                    $parent = $(this.element).parent();
                this.player.destroy();
                $parent.append(frameHtml);
              } catch (ex) {}
            }).bind(playerObj);

            $(this).data('player', playerObj).addClass('product-media--video-loaded');

            if(settings.onYouTubeInit) {
              settings.onYouTubeInit(playerObj);
            }
          }).bind(this);

          if (window.YT && window.YT.Player) {
            loadYoutubeVideo();
          } else {
            window.onYouTubeIframeAPIReady = function(){
              if(existingYTCB) {
                existingYTCB();
              }
              loadYoutubeVideo();
            }
            theme.loadScriptOnce('https://www.youtube.com/iframe_api');
          }
        }
      }
    });

    // set up a 3d model when it first appears
    $(container).on('mediaVisible mediaVisibleInitial', '.product-media--model:not(.product-media--model-loaded):not(.product-media--model-loading)', function(e){
      var element = $(this).find('model-viewer')[0],
          autoplay = e.type != 'mediaVisibleInitial' || _autoplayOnceIfRequested($(this));
      // do not run this twice
      $(this).addClass('product-media--model-loading');
      // load viewer
      theme.loadStyleOnce('https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css');
      window.Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: (function(){
            $(this).data('player', new Shopify.ModelViewerUI(element));
            // add mouseup event proxy to fix carousel swipe gestures
            $('<div class="theme-event-proxy">').on('mouseup', function(e){
              e.stopPropagation();
              e.preventDefault();
              var newEventTarget = $(e.currentTarget).closest('.product-media')[0];
              newEventTarget.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
            }).appendTo(
              $(this).find('.shopify-model-viewer-ui__controls-overlay')
            );
            // when playing or loading, prevent bubbling of mouse/touch start
            $(this).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function(){
              $(this).closest('.product-media').on('touchstart.themeModelViewerFix mousedown.themeModelViewerFix', function(e){
                e.stopPropagation();
              });
            }).on('shopify_model_viewer_ui_toggle_pause', function(){
              $(this).closest('.product-media').off('.themeModelViewerFix');
            });
            // set class and re-trigger visible event now loaded
            $(this).addClass('product-media--model-loaded').removeClass('product-media--model-loading');
            if(settings.onModelViewerInit) {
              settings.onModelViewerInit(element);
            }
            if(autoplay) {
              $(this).trigger('mediaVisible');
            }
          }).bind(this)
        }
      ]);
    });

    // Third, load AR viewer
    if($('.model-json', container).length) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: _._setupShopifyXr.bind($('.model-json', container))
        }
      ]);

      // pause video when a 3d model is launched in AR
      $(document).on('shopify_xr_launch', function(){
        $('.product-media--video-loaded').each(function(){
          $(this).data('player').pause();
        });
      });
    }

    // 3d model in first place - start in paused mode
    setTimeout((function(){
      $('.product-media:first', this).filter('.product-media--model').trigger('mediaVisibleInitial');
    }).bind(container), 50);
  }

  this.destroy = function(container){
    $(document).off('shopify_xr_launch');
    $(container).off('mediaVisible mediaVisibleInitial mediaHidden');
    $('.product-media--video-loaded, .product-media--model-loaded', container).each(function(){
      $(this).data('player').destroy();
    }).removeClass('product-media--video-loaded product-media--model-loaded');
    $('.product-media--video video', container).off('playing pause ended');
    $('model-viewer', container).off('shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause');
    $('.product-media--model .theme-event-proxy').off('mouseup').remove();
  }
}


/*================ Sections ================*/
/**
 * Sidebar section Script
 * ------------------------------------------------------------------------------
 *
   * @namespace sidebar
 */

theme.Sidebar = (function() {
  /**
   * Sidebar page constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Sidebar(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);

    // check sidebar exists
    this.sidebarExists = !!$('.sidebar', container).length;
    $('.template-index').toggleClass('page-has-sidebar', this.sidebarExists);
  }


  Sidebar.prototype = $.extend({}, Sidebar.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
    }
  });

  return Sidebar;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedMedia: '[data-product-featured-media]',
    productFeaturedMediaWithGallery: '[data-product-featured-media]:not(.product-image--no-gallery) .product-image__link',
    productThumbnailForCarouselContainer: '.product-thumbnails--inline',
    productThumbnailImage: '.product-thumbnails__link, .carousel-media .product-image__link',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    zoomValidThumbs: '.product-thumbnails--desktop .product-thumbnails__item-media-image [data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    styledSelect: '.selector-wrapper select',
    skuWrapper: '.product-sku',
    sku: '.product-sku__value',
    unitPrice: '.unit-price'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedMedia, this.$container);
    this.$zoomValidThumbs = $(selectors.zoomValidThumbs, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if(this.$container.find(selectors.skuWrapper)) {
      this.$container.on('variantChange' + this.namespace, this.updateSKU.bind(this));
    }

    if (this.$featuredImage.length > 0) {
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    this.$thumbnails = $(selectors.productThumbnailImage, container);
    if (this.$thumbnails.length > 0) {
      this.$container.on('click' + this.namespace, selectors.productThumbnailImage, this.selectThumbnailImage.bind(this));
    }

    // image zoom
    this.$container.on('click' + this.namespace, selectors.productFeaturedMediaWithGallery, this.openGallery.bind(this));

    // image media
    theme.ProductMedia.init(this.$container);

    // style dropdowns
    theme.styleVariantSelectors($(selectors.styledSelect, container), options.product);

    if(this.$thumbnails.length > 0) {
      // mobile carousel
      this.$thumbnailForCarouselContainer = $(selectors.productThumbnailForCarouselContainer, container);
      this.assessMobileCarousel.bind(this)();
      $(window).on('debouncedresize' + this.namespace, this.assessMobileCarousel.bind(this));

      // reveal thumbnails now - avoiding lazysizes + slick conflict
      this.$thumbnails.find('.lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');
    }

    // note: adds event to window
    theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Switches thumbnails into a carousel on mobile
     */
    assessMobileCarousel: function() {
      // test by checking if single image is visible
      if(!this.$featuredImage.is(':visible')) {
        if(!this.$thumbnailForCarouselContainer.hasClass('slick-slider')) {
          this.$thumbnailForCarouselContainer.addClass('slick-slider');

          theme.ProductMedia.destroy(this.$container); // destroy existing media

          this.$thumbnailForCarouselContainer.slick({
            autoplay: false,
            fade: false,
            infinite: false,
            useTransform: true,
            dots: true,
            arrows: true,
            prevArrow: theme.icons.slideshowPrevArrow,
            nextArrow: theme.icons.slideshowNextArrow,
            appendArrows: $('.slick-external-controls .slick-external-arrows', this.$container),
            appendDots: $('.slick-external-controls .slick-external-dots', this.$container),
            adaptiveHeight: true,
            initialSlide: $('.product-thumbnails__item--active', this.$thumbnailForCarouselContainer).index() || 0
          });
          // create carousel media
          this.$thumbnailForCarouselContainer.find('.product-thumbnails__item').each(function(){
            $('<div class="carousel-media">').append(
              $(this).find('.thumbnail-media-template').html()
            ).prependTo(this);
          });
          theme.ProductMedia.init(this.$container, {
            onPlyrPlay: function(evt){
              $(evt.target).closest('.product-media')
                .find('.plyr__controls')
                .off('.themeModelViewerFix')
                .on('touchstart.themeModelViewerFix touchmove.themeModelViewerFix touchend.themeModelViewerFix mousedown.themeModelViewerFix mousemove.themeModelViewerFix mouseup.themeModelViewerFix', function(e){
                e.stopPropagation();
              });
            }
          });
          this.$thumbnailForCarouselContainer.find('.product-media').trigger('mediaVisibleInitial');
          this.$thumbnailForCarouselContainer.on('afterChange', function(evt, slick, current){
            // notify media of visibility
            var $currentMedia = $('.product-media', slick.$slides[current]);
            $('.product-media').not($currentMedia).trigger('mediaHidden');
            $currentMedia.trigger('mediaVisible');
            // fix tabbing
            theme.productGallerySlideshowTabFix(slick.$slides, current);
          });
        }
      } else {
        if(this.$thumbnailForCarouselContainer.hasClass('slick-slider')) {
          // remove carousel media
          theme.ProductMedia.destroy(this.$container);
          this.$thumbnailForCarouselContainer.find('.carousel-media').remove();

          this.$thumbnailForCarouselContainer.slick('unslick').off('afterChange');
          this.$thumbnailForCarouselContainer.removeClass('slick-slider');
          theme.ProductMedia.init(this.$container); // init original large media
          this.$thumbnailForCarouselContainer.find('.product-media').trigger('mediaVisibleInitial');
        }
      }
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('product-price--unavailable');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('product-price--unavailable');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }

      // backorder
      var $backorderContainer = $('.backorder', this.$container);
      if($backorderContainer.length) {
        if(variant && variant.available) {
          var $option = $(selectors.originalSelectorId + ' option[value="' + variant.id + '"]', this.$container);
          if(variant.inventory_management && $option.data('stock') == 'out') {
            $backorderContainer.find('.backorder__variant').html(this.productSingleObject.title + (variant.title.indexOf('Default') >= 0 ? '' : ' - ' + variant.title) );
            $backorderContainer.show();
          } else {
            $backorderContainer.hide();
          }
        } else {
          $backorderContainer.hide();
        }
      }
    },

    /**
     * Get the display unit for unit pricing
     */
    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var $price = $(selectors.productPrice, this.$container);
      var $unitPrice = $(selectors.unitPrice, this.$container);

      $price.html('<span class="theme-money">' + slate.Currency.formatMoney(variant.price, theme.moneyFormat) + '</span>');

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html('<span class="theme-money">' + slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat) + '</span>');
        $compareEls.removeClass('hide');
        $price.addClass('product-price__reduced');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
        $price.removeClass('product-price__reduced');
      }

      if(variant.unit_price_measurement){
        var $newUnitPriceArea = $('<div class="unit-price small-text">');
        $('<span class="unit-price__price theme-money">').html(slate.Currency.formatMoney(variant.unit_price, theme.moneyFormat)).appendTo($newUnitPriceArea);
        $('<span class="unit-price__separator">').html(theme.strings.unitPriceSeparator).appendTo($newUnitPriceArea);
        $('<span class="unit-price__unit">').html(this._getBaseUnit(variant)).appendTo($newUnitPriceArea);
        if($unitPrice.length) {
          $unitPrice.replaceWith($newUnitPriceArea);
        } else {
          $(selectors.priceWrapper, this.$container).append($newUnitPriceArea);
        }
      } else {
        $unitPrice.remove();
      }
    },

    /**
     * Updates the SKU
     */
    updateSKU: function(evt) {
      var variant = evt.variant;

      if (variant && variant.sku) {
        $(selectors.skuWrapper, this.$container).removeClass('product-sku--empty');
        $(selectors.sku, this.$container).html(variant.sku);
      } else {
        $(selectors.skuWrapper, this.$container).addClass('product-sku--empty');
        $(selectors.sku, this.$container).empty();
      }
    },

    /**
     * Display selected thumbnail
     */
    selectThumbnailImage: function(evt) {
      var $thumbnailContainer = $(evt.currentTarget).parent();
      if(!$thumbnailContainer.hasClass('product-thumbnails__item--active')) {
          // if a carousel exists
        if(this.$thumbnailForCarouselContainer.hasClass('slick-slider')) {
          if($thumbnailContainer.hasClass('carousel-media')) {
            // selected actual slide - do nothing
          } else {
            // hidden thumbnail, e.g. variant image change
            var mediaId = $thumbnailContainer.find('[data-thumbnail-media-id]').data('thumbnail-media-id');
            var slickIndex = this.$thumbnailForCarouselContainer.find('[data-thumbnail-media-id="' + mediaId + '"]').closest('.slick-slide').data('slick-index');
            this.$thumbnailForCarouselContainer.slick('slickGoTo', slickIndex);
          }
        } else {
          // with thumbnails
          theme.ProductMedia.destroy(this.$container);
          this.$featuredImage.html(
            $(evt.currentTarget).find('.thumbnail-media-template').html()
          );
          // load media and play immediately
          theme.ProductMedia.init(this.$container, {
            autoplayFirstMedia: true
          });

          $thumbnailContainer
            .addClass('product-thumbnails__item--active')
            .siblings('.product-thumbnails__item--active')
            .removeClass('product-thumbnails__item--active');
        }
      }
      evt.preventDefault();
    },

    /**
     * Updates the DOM with the specified image URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      if(variant.featured_media) {
        $('.product-thumbnails__link[data-thumbnail-media-id="' + variant.featured_media.id + '"]').trigger('click');
      }
    },

    /**
     * Show gallery of all product images
     */
    openGallery: function(evt) {
      evt.preventDefault();

      var pswpElement = document.querySelectorAll('.pswp')[0];

      var items = [];
      if(this.$zoomValidThumbs.length) {
        this.$zoomValidThumbs.each(function(){
          var item = {
            src: $(this).attr('href'),
            w: $(this).data('image-w'),
            h: $(this).data('image-h')
          };
          var img = $(this).find('img')[0];
          if(typeof img.currentSrc !== 'undefined') {
            item.msrc = img.currentSrc;
          }
          items.push(item);
        });
      } else {
        var item = {
          src: this.$featuredImage.find('a').attr('href'),
          w: this.$featuredImage.data('image-w'),
          h: this.$featuredImage.data('image-h')
        };
        var img = this.$featuredImage.find('img')[0];
        if(typeof img.currentSrc !== 'undefined') {
          item.msrc = img.currentSrc;
        }
        items.push(item);
      }

      var options = {
        index: $(evt.target).closest('a').data('image-index'),
        history: false,
        captionEl: false,
        shareEl: false,
        fullscreenEl: false,
        getThumbBoundsFn: (function(index) {
          var thumbnail = this.$zoomValidThumbs.is(':visible') ? this.$zoomValidThumbs[index].getElementsByTagName('img')[0] : this.$featuredImage.find('img')[0],
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }).bind(this)
      };

      // Initializes and opens PhotoSwipe
      this.imageGallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      this.imageGallery.init();
      this.imageGallery.listen('destroy', (function(){
        this.imageGallery = null;
      }).bind(this));
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
      $(window).off(this.namespace);
      if(this.imageGallery) {
        this.imageGallery.close();
      }
      if(this.$thumbnailForCarouselContainer) {
        this.$thumbnailForCarouselContainer.filter('.slick-slider').slick('unslick').off('afterChange');
      }
      theme.ProductMedia.destroy(this.$container);
    }
  });

  return Product;
})();

/**
 * Header Script
 * ------------------------------------------------------------------------------
 *
 * @namespace Header
 */

theme.Header = (function() {
  /**
   * Header section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Header(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.mobileMenuTransitionTime = 500;

    this.$searchBar = $('.search-bar', container);
    this.$newsletterSignupButton = $('.js-header-newsletter-open', this.$container);
    this.$searchInput = $('.search-form__input');

    /**
     * Making search bar un-tabbable on page load
     */
    $('.header-search-form', this.$container).find('a, button, input').attr('tabindex', '-1');

    /**
     * Toggle header search bar open
     */
    $('.js-header-search-trigger', this.$container).on('click' + this.namespace, (function(e){
      e.preventDefault();
      $('body').toggleClass('show-search');
      $('.header-search-form', this.$container).find('a, button, input').removeAttr('tabindex');
      $('.header-search-form .search-form__input', this.$container).focus();
    }).bind(this));

    /**
     * Fetch search results for entered text
     */
    $('.search-form__input[data-live-search="true"]', this.$container).on('change' + this.namespace + ' keyup' + this.namespace + ' paste' + this.namespace, (function(e){
      this.fetchSearchResults.bind(this)(e);
    }).bind(this));

    // mobile menu events
    $(this.$container).on('click' + this.namespace, '.js-mobile-menu-icon', this.mobileMenuOpen.bind(this));
    $(this.$container).on('click' + this.namespace, '.js-close-mobile-menu', this.mobileMenuClose.bind(this));
    this.$mobileDropdownContainer = $('.mobile-nav-column-inner', container);
    $(this.$container).on('click' + this.namespace, '.js-mobile-dropdown-trigger', this.mobileMenuDropdownOpen.bind(this));
    $(this.$container).on('click' + this.namespace, '.js-mobile-dropdown-return', this.mobileMenuDropdownClose.bind(this));


    // open newsletter form on click
    if(this.$newsletterSignupButton.length > 0) {
      $(this.$container).on('click' + this.namespace, '.js-header-newsletter-open', function(){
        $.colorbox({
          transition: 'none',
          html: $('.header-newsletter-wrapper').html(),
          onOpen: theme.colorboxFadeTransOnOpen,
          onComplete: theme.colorboxFadeTransOnComplete
        });
      });
      // show newsletter form if it contains messages
      if($('.header-newsletter-wrapper .form-success, .header-newsletter-wrapper .errors').length) {
        $.colorbox({
          transition: 'fade',
          html: $('.header-newsletter-wrapper').html(),
          onOpen: theme.colorboxFadeTransOnOpen,
          onComplete: theme.colorboxFadeTransOnComplete
        });
      }
    }

    // aria labels
    $('.main-nav__has-dropdown > a, .main-nav__child-has-dropdown > a', this.$container).attr('aria-haspopup', 'true').attr('aria-expanded', 'false');
    this.$container.on('mouseenter' + this.namespace + ' mouseleave' + this.namespace, '.main-nav__has-dropdown, .main-nav__child-has-dropdown', function(evt){
      if(evt.type == 'mouseenter') {
        $(this).children('[aria-expanded]').attr('aria-expanded', true);
        $(this).addClass('show-dropdown');
      } else {
        $(this).children('[aria-expanded]').attr('aria-expanded', false);
        $(this).removeClass('show-dropdown');
      }
    });

    // keyboard navigation - press enter to open
    this.$container.on('keydown' + this.namespace, '.main-nav__has-dropdown > .main-nav__link, .main-nav__child-has-dropdown > .main-nav__child-link', (function(evt){
      if(evt.which == 13) {
        if($(evt.target).parent().hasClass('show-dropdown')) {
          $(evt.target).trigger('mouseleave');
        } else {
          $(evt.target).trigger('mouseenter');
        }
        evt.preventDefault();
      }
    }).bind(this));

    // touch events
    $(this.$container).on('touchstart' + this.namespace + ' touchend' + this.namespace + ' click' + this.namespace, '.main-nav__has-dropdown > .main-nav__link, .main-nav__child-has-dropdown > .main-nav__child-link', function(evt){
      // unless showing mobile menu
      if(!$(this).next('.dropdown-chevron').is(':visible')) {
        if(evt.type == 'touchstart') {
          $(this).data('touchstartedAt', evt.timeStamp);
        } else if(evt.type == 'touchend') {
          // down & up in under a second - presume tap
          if(evt.timeStamp - $(this).data('touchstartedAt') < 1000) {
            $(this).data('touchOpenTriggeredAt', evt.timeStamp);
            if($(this).parent().hasClass('show-dropdown')) {
              // trigger close
              $(this).trigger('mouseleave');
            } else {
              // trigger close on any open items
              $('.main-nav .show-dropdown').removeClass('show-dropdown').children('a').attr('aria-expanded', false);
              // trigger open
              $(this).trigger('mouseenter');
            }
            // prevent fake click
            return false;
          }
        } else if(evt.type == 'click') {
          // if touch open was triggered very recently, prevent click event
          if($(this).data('touchOpenTriggeredAt') && evt.timeStamp - $(this).data('touchOpenTriggeredAt') < 1000) {
            return false;
          }
        }
      }
    });

    // keep menus in viewport
    this.assessMenuPositions.bind(this)();
    $(window).on('debouncedresize' + this.namespace, this.assessMenuPositions.bind(this));

    // localization
    $('.disclosure', this.$container).each(function(){
      $(this).data('disclosure', new theme.Disclosure($(this)));
    });
  };


  Header.prototype = $.extend({}, Header.prototype, {
    /**
    * Ensure dropdown menus do not go off the right-edge of the page
    */
    assessMenuPositions: function(){
      var windowWidth = $(window).width();
      $('.main-nav__dropdown', this.$container).each(function(){
        var thisWidth = $(this).outerWidth();

        // this dropdown
        var gutter = 20;
        var marginLeft = parseInt($(this).css('margin-left')) || 0;
        var offEdgeAmount = windowWidth - gutter - (($(this).offset().left - marginLeft) + thisWidth);
        $(this).css('margin-left', offEdgeAmount < 0 ? offEdgeAmount : '');

        // child dropdown
        $(this).toggleClass(
          'main-nav__dropdown--expand-left',
          $(this).offset().left + thisWidth * 2 > windowWidth
        );
      });
    },

    /**
    * Fetching search results
    */
    fetchSearchResults: function(e){
      var $input = $(e.target);
      var terms = $input.val();

      // only do something if search terms have changed
      if(terms != $input.data('previous-terms')) {
        $input.data('previous-terms', terms);

        // is it a valid search term
        if(terms.length > 0) {
          // abort first, let callbacks run
          if(this.searchXhr) {
            this.searchXhr.abort();
          }

          // add class to show results, in case it's closed. Also hide existing items.
          this.$searchBar.addClass('search-bar--show-results search-bar--loading').removeClass('search-bar--has-results');

          // build search url
          var $form = $input.closest('form');
          var searchUrl = $form.attr('action') + '?' + $form.serialize();

          // build request for api or fallback
          var ajaxUrl, ajaxData;
          if(theme.shopifyFeatures.predictiveSearch) {
            // use the API
            ajaxUrl = theme.routes.search_url + '/suggest.json';
            ajaxData = {
              "q": $form.find('input[name="q"]').val(),
              "resources": {
                "type": $form.find('input[name="type"]').val(),
                "limit": 6,
                "options": {
                  "unavailable_products": 'last'
                }
              }
            };
          } else {
            // use the theme template fallback
            ajaxUrl = $form.attr('action') + '?' + $form.serialize() + '&view=json';
            ajaxData = null;
          }

          // fetch search results
          this.searchXhr = $.ajax({
            url: ajaxUrl,
            data: ajaxData,
            dataType: "json",
            success: this.buildSearchResults.bind(this, searchUrl)
          }).always(function(){
            this.searchXhr = null;
            this.$searchBar.removeClass('search-bar--loading');
          }.bind(this));
        } else {
          if(this.searchXhr) {
            this.searchXhr.abort();
          }
          this.$searchBar.removeClass('search-bar--loading search-bar--has-results');
        }
      }
    },

    /**
    * Build search results from response
    */
    buildSearchResults: function(searchUrl, response){
      this.$searchBar.addClass('search-bar--has-results');
      var $resultsContainer = $('.search-bar__results-list', this.$searchBar).empty();
      if(
        (response.resources.results.products && response.resources.results.products.length > 0) ||
        (response.resources.results.pages && response.resources.results.pages.length > 0) ||
        (response.resources.results.articles && response.resources.results.articles.length > 0)
      ) {
        var $productResults = $('<div class="search-bar__results-products">');
        var $pageResults = $('<div class="search-bar__results-pages">');

        if(response.resources.results.products) {
          for(var i = 0; i < response.resources.results.products.length; i++) {
            var result = response.resources.results.products[i];

            var $item = $('<a class="mini-product">').attr('href', result.url);
            var $imgCont = $('<div class="mini-product__image-container">').appendTo($item);
            if(result.image) {
              $('<img class="mini-product__image" alt="" role="presentation"/>').attr('src', slate.Image.getSizedImageUrl(result.image, '100x100_crop_center')).appendTo($imgCont);
            }
            var $details = $('<div class="mini-product__details">').appendTo($item);
            $('<div class="mini-product__title">').html(result.title).appendTo($details);

            if(this.$searchInput.data('live-search-vendor')) {
              $('<div class="mini-product__vendor small-text">').html(result.vendor).appendTo($details);
            }

            if(this.$searchInput.data('live-search-price')) {
              var $price = $('<div class="mini-product__price">').html(slate.Currency.formatMoney(result.price_min, theme.moneyFormat)).appendTo($details);
              if(parseFloat(result.compare_at_price_min) > parseFloat(result.price_min)) {
                $price.addClass('mini-product__price--on-sale');
              }
            }

            $item.appendTo($productResults);
          }
        }

        if(response.resources.results.pages) {
          for(var i = 0; i < response.resources.results.pages.length; i++) {
            var result = response.resources.results.pages[i];
            $('<a class="search-bar__results-pages__link">').attr('href', result.url).html(result.title).appendTo($pageResults);
          }
        }

        if(response.resources.results.articles) {
          for(var i = 0; i < response.resources.results.articles.length; i++) {
            var result = response.resources.results.articles[i];
            $('<a class="search-bar__results-pages__link">').attr('href', result.url).html(result.title).appendTo($pageResults);
          }
        }

        $resultsContainer.append($productResults);

        if($pageResults.children().length) {
          $('<h6 class="search-bar__results-pages-title small-cap-heading">').html(theme.strings.searchResultsPages).prependTo($pageResults);
          $resultsContainer.append($pageResults);
        }
        $('<a class="search-bar__results-all-link">').html(theme.strings.searchResultsViewAll).attr('href', searchUrl).appendTo($resultsContainer);
      } else {
        $('<div>').html(theme.strings.searchResultsNoResults).appendTo($resultsContainer);
      }
    },

    /**
     * Event for showing the mobile navigation
     */
    mobileMenuOpen: function(evt) {
      evt.preventDefault();
      $(document.body).addClass('mobile-menu-prime');
      setTimeout(function(){
        $(document.body).addClass('mobile-menu-open');
      }, 10);
    },

    /**
     * Event for closing the mobile navigation
     */
    mobileMenuClose: function(evt) {
      evt.preventDefault();
      $(document.body).removeClass('mobile-menu-open');
      setTimeout(function(){
        $(document.body).removeClass('mobile-menu-prime');
      }, 500);
    },

    /**
     * Event for opening a mobile dropdown menu
     */
    mobileMenuDropdownOpen: function(evt) {
      evt.preventDefault();
      var $dropdownToShow = $(evt.currentTarget).siblings('.main-nav__dropdown');
      if($dropdownToShow.length) {
        // show level 2 dropdown
        var $newDropdown = $dropdownToShow.clone().wrap('<div class="mobile-nav-menu-container mobile-dropdown mobile-menu-level-2">').parent();
        // add return link
        $('<a class="mobile-dropdown__back js-mobile-dropdown-return" href="#">').html(
          [
            '<span class="feather-icon">',
            theme.icons.arrowLeft,
            '</span><span class="mobile-dropdown__back-text">',
            $(evt.currentTarget).siblings('.main-nav__link').html(),
            '</span>'
          ].join('')
        ).prependTo($newDropdown);
        this.$mobileDropdownContainer.append($newDropdown);
        setTimeout((function(){
          this.$mobileDropdownContainer.addClass('show-mobile-menu-level-2');
        }).bind(this), 10);
      } else {
        $dropdownToShow = $(evt.currentTarget).siblings('.main-nav__sub-dropdown');
        if($dropdownToShow.length) {
          // show level 3 dropdown
          var $newDropdown = $dropdownToShow.clone().wrap('<div class="mobile-nav-menu-container mobile-dropdown mobile-menu-level-3">').parent();
          // add return link
          $('<a class="mobile-dropdown__back js-mobile-dropdown-return" href="#">').html(
            [
              '<span class="feather-icon">',
              theme.icons.arrowLeft,
              '</span><span class="mobile-dropdown__back-text">',
              $(evt.currentTarget).siblings('.main-nav__child-link').html(),
              '</span>'
            ].join('')
          ).prependTo($newDropdown);
          this.$mobileDropdownContainer.append($newDropdown);
          setTimeout((function(){
            this.$mobileDropdownContainer.addClass('show-mobile-menu-level-3');
          }).bind(this), 10);
        }
      }
    },

    /**
     * Event for closing a mobile dropdown menu
     */
    mobileMenuDropdownClose: function(evt) {
      evt.preventDefault();
      if(this.$mobileDropdownContainer.hasClass('show-mobile-menu-level-3')) {
        // transition out level 3 dropdown
        this.$mobileDropdownContainer.removeClass('show-mobile-menu-level-3');
        // remove menu element after transition time
        var $toRemove = this.$mobileDropdownContainer.find('.mobile-menu-level-3');
        setTimeout(function(){
          $toRemove.remove();
        }, this.mobileMenuTransitionTime);
      } else if(this.$mobileDropdownContainer.hasClass('show-mobile-menu-level-2')) {
        // transition out level 2 dropdown
        this.$mobileDropdownContainer.removeClass('show-mobile-menu-level-2');
        // remove menu element after transition time
        var $toRemove = this.$mobileDropdownContainer.find('.mobile-menu-level-2');
        setTimeout(function(){
          $toRemove.remove();
        }, this.mobileMenuTransitionTime);
      }
    },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      this.$container.off(this.namespace);
      $('.js-header-search-trigger', this.$container).off(this.namespace);
      $('.search-form__input', this.$container).off(this.namespace);
      $(document).off(this.namespace);
      $(window).off(this.namespace);
      this.$searchBar.off(this.namespace);
      $('.disclosure', this.$container).each(function(){
        $(this).data('disclosure').unload();
      });
    }
  });

  return Header;
})();

/**
 * Footer Script
 * ------------------------------------------------------------------------------
 *
 * @namespace Footer
 */

theme.Footer = (function() {
  /**
   * Footer section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Footer(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);

    // localization
    $('.disclosure', this.$container).each(function(){
      $(this).data('disclosure', new theme.Disclosure($(this)));
    });
  };

  Footer.prototype = $.extend({}, Footer.prototype, {
    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      $('.disclosure', this.$container).each(function(){
        $(this).data('disclosure').unload();
      });
    }
  });

  return Footer;
})();

/**
 * Banner Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace Banner
 */

theme.Banner = (function() {
  /**
   * Banner section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Banner(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$slideshow = $('.slideshow', this.$container);
    this.stackBreakpoint = 840;

    // Initialise slideshow
    this.$slideshow.on('init', function(){
      $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
    }).slick({
      autoplay: this.$slideshow.hasClass('auto-play'),
      fade: this.$slideshow.data('slide-transition') == 'fade',
      infinite: true,
      useTransform: true,
      arrows: false,
      dots: this.$slideshow.find('.slide').length > 1,
      autoplaySpeed: this.$slideshow.data('slide-speed'),
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            fade: false
          }
        },
        {
          breakpoint: this.stackBreakpoint,
          settings: {
            fade: false,
            dots: this.$slideshow.find('.slide').length > 1
          }
        }
      ]
    });

    // Slideshow
    this.$companionContent = $('.banner-section__companion-column .overlay__inner', this.$container);
    if(this.$companionContent.children().length > 1) {
      this.assessCompanionCarousel.bind(this)();
      $(window).on('debouncedresize' + this.namespace, this.assessCompanionCarousel.bind(this));
    }
  };

  Banner.prototype = $.extend({}, Banner.prototype, {
    /**
    * Enable/disable carousel on companion content based on screen size
    */
    assessCompanionCarousel: function(){
      if($(window).width() < this.stackBreakpoint) {
        if(!this.$companionContent.hasClass('slick-slider')) {
          this.$companionContent.addClass('slick-slider').children().addClass('slide');
          this.$companionContent.parent().addClass('overlay--with-slider');
          this.$companionContent.slick({
            autoplay: true,
            fade: false,
            infinite: true,
            useTransform: true,
            arrows: false,
            dots: false,
            autoplaySpeed: 7000 // 7 seconds between slides
          });
        }
      } else {
        if(this.$companionContent.hasClass('slick-slider')) {
          this.$companionContent.slick('unslick');
          this.$companionContent.parent().removeClass('overlay--with-slider');
          this.$companionContent.removeClass('slick-slider').children().removeClass('slide');
        }
      }
    },

    /**
    * Event callback for Theme Editor `shopify:block:select` event
    */
    onBlockSelect: function(evt) {
      $(evt.target).closest('.slick-slider')
      .slick('slickGoTo', $(evt.target).data('slick-index'))
      .slick('slickPause');
    },

    /**
    * Event callback for Theme Editor `shopify:block:deselect` event
    */
   onBlockDeselect: function(evt) {
    $(evt.target).closest('.slick-slider')
      .slick('slickPlay');
   },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      this.$slideshow.slick('unslick').off('init');
      if(this.$companionContent.hasClass('slick-slider')) {
        this.$companionContent.slick('unslick');
      }
      $(window).off(this.namespace);
    }
  });

  return Banner;
})();

/**
 * Featured Collection Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace FeaturedCollection
 */

theme.FeaturedCollection = (function() {
  /**
   * FeaturedCollection section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function FeaturedCollection(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$carousel = $('[data-grid-carousel]', this.$container);

    if(this.$carousel.length) {
      // switch to swiper classes
      this.$carousel
        .addClass('swiper-container')
        .children('.grid')
        .addClass('swiper-wrapper')
        .removeClass('grid')
        .children()
        .addClass('swiper-slide')
        .removeClass('grid__item');
      // init swiper
      this.carouselSwiper = new Swiper(this.$carousel, {
        init: false,
        //loop: true,
        //loopedSlides: 6,
        freeMode: false,
        slidesPerView: this.$carousel.data('grid-carousel-columns'),
        autoHeight: false,
        grabCursor: true,
        effect: 'slide',
        centeredSlides: false,
        spaceBetween: 14,
        navigation: {
          nextEl: $('.carousel-next', this.$container),
          prevEl: $('.carousel-prev', this.$container),
        },
        autoplay: false,
        breakpoints: {
          768: {
            slidesPerView: 2
          },
          560: {
            spaceBetween: 12,
            freeMode: true,
            slidesPerView: 2
          }
        }
      });
      this.carouselSwiper.once('init', function(evt){
        this.$el.find('.swiper-slide-duplicate .lazyloading').addClass('lazyload');
      });
      this.carouselSwiper.init();
    }

    // note: adds event to window
    theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
  };

  FeaturedCollection.prototype = $.extend({}, FeaturedCollection.prototype, {
    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      $(window).off(this.namespace);
      if(this.$carousel.length) {
        this.carouselSwiper.destroy();
      }
    }
  });

  return FeaturedCollection;
})();

/**
 * MiniCollectionList Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace MiniCollectionList
 */

theme.MiniCollectionList = (function() {
  /**
   * MiniCollectionList section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function MiniCollectionList(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$slideshow = $('.swiper-container', this.$container);

    /**
     * Swiper slideshow
     */
    var slidesperView = 4;
    if($('.sidebar').length) {
      slidesperView = 3;
    }

    var count = this.$slideshow.find('.swiper-slide', this.$container).length;
    if(count > 0) {
      this.mySwiper = new Swiper(this.$slideshow, {
        //loop: true,
        //loopedSlides: count,
        freeMode: true,
        slidesPerView: slidesperView,
        grabCursor: true,
        spaceBetween: 14,
        navigation: {
          nextEl: '.mini-collection-slider-next',
          prevEl: '.mini-collection-slider-prev',
        },
        breakpoints: {
          900: {
            slidesPerView: slidesperView - 1,
          },
          720: {
            slidesPerView: slidesperView - 2,
          },
          560: {
            slidesPerView: 2,
            spaceBetween: 12
          },
          490: {
            slidesPerView: 1
          }
        }
      });
    }
  };


  MiniCollectionList.prototype = $.extend({}, MiniCollectionList.prototype, {
    /**
    * Event callback for Theme Editor `shopify:block:select` event
    */
    onBlockSelect: function(evt) {
      if(this.mySwiper) {
        this.mySwiper.slideTo($(evt.target).data('swiper-index'), 1000);
      }
    },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      if(this.mySwiper) {
        this.mySwiper.destroy();
      }
    }
  });

  return MiniCollectionList;
})();

/**
 * Map Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace Map
 */

theme.Map = (function() {
  /**
   * Map section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */

  var config = {
    zoom: 14,
    styles: {
      default: [],
      silver: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}],
      retro: [{"elementType":"geometry","stylers":[{"color":"#ebe3cd"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#523735"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f1e6"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#c9b2a6"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#dcd2be"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#ae9e90"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b9d3c2"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#92998d"}]}],
      dark: [{"elementType":"geometry","stylers":[{"color":"#212121"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#212121"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#757575"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#181818"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"poi.park","elementType":"labels.text.stroke","stylers":[{"color":"#1b1b1b"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#8a8a8a"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#373737"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#3c3c3c"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#4e4e4e"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#3d3d3d"}]}],
      night: [{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#17263c"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}],
      aubergine: [{"elementType":"geometry","stylers":[{"color":"#1d2c4d"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#8ec3b9"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#1a3646"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#64779e"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#334e87"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#023e58"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#283d6a"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6f9ba5"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#023e58"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#3C7680"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#304a7d"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#2c6675"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#255763"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#b0d5ce"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#023e58"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"transit.line","elementType":"geometry.fill","stylers":[{"color":"#283d6a"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#3a4762"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#0e1626"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#4e6d70"}]}]
    }
  };

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };



  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) return;

    if (Shopify.designMode) {
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).show().after(
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
    }
  };


  function Map(container) {

    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');
    this.style = this.$map.data('map-style');
    this.loaded = false;

    if (this.$map.length === 0 || typeof this.key !== 'string' || this.key === '') {
      return;
    }

    $(window).on('scroll' + this.namespace + ' load' + this.namespace, this.assessVisibility.bind(this));
    this.assessVisibility.bind(this)();
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }


  Map.prototype = $.extend({}, Map.prototype, {

    assessVisibility: function(){
      if( this.$container !== false
          && this.$container.offset().top < $(window).scrollTop() + $(window).height()
          && this.$container.offset().top + this.$container.outerHeight() > $(window).scrollTop() ) {
        $(window).off(this.namespace);
        theme.loadScriptOnce('https://maps.googleapis.com/maps/api/js?key=' + this.key, this.createMap.bind(this));
      }
    },

    createMap: function() {
      var $map = this.$map;
      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles[this.style],
              center: results[0].geometry.location,
              draggable: true,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
              zoomControl: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(window, 'resize', function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              map.panBy(0, 50);
              $map.removeAttr('style');
            });
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      if(window.google) {
        google.maps.event.clearListeners(this.map, 'resize');
      }
      $(window).off(this.namespace);
    }
  });
  return Map;
})();

/**
 * Video Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace Video
 */

theme.Video = (function() {
  /**
   * Video section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Video(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);

    var $iframeVideo = $(
      'iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]',
      this.$container
    );
    var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's 'incorrect iFrame content on 'back'' bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });

    // Handle a cover image
    this.$cover = $('.video-container__cover', this.$container);
    if(this.$cover.length) {
      this.$container.on('click', '.video-container__play', this.coverPlayImage.bind(this));
    }
  }

  Video.prototype = $.extend({}, Video.prototype, {
    /**
     * Callback for clicking the cover image's play button
     */
    coverPlayImage: function(evt) {
      evt.preventDefault();
      var $videoContainer = $('.video-container', this.$container);
      var $videoTemplate = $('.video-container__video-template', this.$container);
      this.$cover.addClass('video-container__cover--playing');
      $videoContainer.append($videoTemplate.html());
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Video;
})();




/**
 * LogoList Section Script
 * ------------------------------------------------------------------------------
 *
 * @namespace LogoList
 */

theme.LogoList = (function() {
  /**
   * LogoList section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function LogoList(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$slideshow = $('.swiper-container', this.$container);

    /**
     * Swiper slideshow
     */
    var slidesPerView = this.$slideshow.data('items-per-row');
    var slideCount = this.$slideshow.find('.swiper-slide').length;
    if(slideCount > 0) {
      this.mySwiper = new Swiper(this.$slideshow, {
        //loop: true,
        //loopedSlides: 6,
        freeMode: true,
        slidesPerView: this.$slideshow.data('items-per-row'),
        grabCursor: true,
        spaceBetween: 14,
        navigation: {
          nextEl: '.logo-list-slider-next',
          prevEl: '.logo-list-slider-prev',
        },
        breakpoints: {
          767: {
            slidesPerView: 3
          },
          560: {
            slidesPerView: 3,
            spaceBetween: 12
          }
        }
      });
    }
  };

  LogoList.prototype = $.extend({}, LogoList.prototype, {
    /**
    * Event callback for Theme Editor `shopify:block:select` event
    */
    onBlockSelect: function(evt) {
      if(this.mySwiper) {
        this.mySwiper.slideTo($(evt.target).data('swiper-index'), 1000);
      }
    },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      if(this.mySwiper) {
        this.mySwiper.destroy();
      }
    }
  });

  return LogoList;
})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * For collection pages
 *
 * @namespace collection-template
 */

theme.CollectionTemplate = (function() {

  var selectors = {
    sortBy: 'select[name="sort_by"]',
    styledSelect: '.styled-dropdown select',
    filterSelects: '.filter select',
    revealFilterButtons: '.collection-filter-control button'
  };

  /**
   * CollectionTemplate section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function CollectionTemplate(container) {
    this.$container = $(container);
    this.namespace = '.collectionTemplate';

    // change sort order
    this.$container.on('change' + this.namespace, selectors.sortBy, this.onSortByChange);

    // filtering
    this.$filters = this.$container.find(selectors.filterSelects);
    this.$filters.on('change' + this.namespace, this.onFilterChange.bind(this));

    // revealing filters on tablet/mobile
    this.$container.on('click' + this.namespace, selectors.revealFilterButtons, this.filterToggle);

    // style dropdowns
    theme.select2.init($(selectors.styledSelect, container));

    // note: adds event to window
    theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
  }

  CollectionTemplate.prototype = $.extend({}, CollectionTemplate.prototype, {
    /**
     * Event callback for when a tag filter changes
     */
    onFilterChange: function() {
      var path = this.$filters.first().data('filter-root');
      // build list of tags
      var tags = [];
      this.$filters.each(function(){
        if($(this).val().length > 0) {
          tags.push($(this).val());
        }
      });
      // add tags to collection path
      path += tags.join('+');
      // preserve sort order
      if(location.search.indexOf('sort_by') > -1) {
        var orderMatch = location.search.match(/sort_by=([^$&]*)/);
        if(orderMatch) {
          path += '?sort_by=' + orderMatch[1];
        }
      }
      window.location = path;
    },

    /**
     * Event callback for when the sort-by dropdown changes
     */
    onSortByChange: function() {
      var queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      queryParams.sort_by = $(this).val();
      location.search = $.param(queryParams);
    },

    /**
     * Function for revealing filter options
     */
    filterToggle: function(evt) {
      var $filterContainer = $('.filters-container');
      var whichSelected = $(this).data('collection-filter-reveal');
      var thisSelectedClass = 'show-' + whichSelected;
      if($filterContainer.hasClass(thisSelectedClass)) {
        $filterContainer.removeClass(thisSelectedClass);
      } else {
        $filterContainer.removeClass('show-filters show-sort').addClass(thisSelectedClass);
      }
      evt.target.blur();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
      this.$filters.off(this.namespace);
      $(selectors.styledSelect, this.$container).select2('destroy');
      $(window).off(this.namespace);
    }
  });

  return CollectionTemplate;
})();

/**
* Page Story Template Section Script
* ------------------------------------------------------------------------------
*
* @namespace featured-collection */

theme.PageStoryTemplate = (function() {

  var selectors = {
    childSections: '[data-nested-section]'
  };

  /**
  * PageStoryTemplate section constructor. Runs on page load as well as Theme Editor
  * `section:load` events.
  * @param {string} container - selector for the section container DOM element
  */
  function PageStoryTemplate(container) {
    this.$container = $(container);
    this.namespace = theme.namespaceFromSection(container);
    this.$childSections = $(selectors.childSections, container);

    // on first page load, all sections are loaded
    if(theme.pageStoryTemplateLoadedBefore) {
      // reload - trigger load on child sections
      this.$childSections.each(function(){
        var event = new CustomEvent('shopify:section:load', {
          bubbles: true,
          cancelable: true,
          detail: {
            sectionId: $(this).data('section-id')
          }
        });
        $(this)[0].dispatchEvent(event);
      });
    } else {
      // first load
      theme.pageStoryTemplateLoadedBefore = true;
    }

    // note: adds event to window
    theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
  }

  PageStoryTemplate.prototype = $.extend({}, PageStoryTemplate.prototype, {

    onBlockSelect: function(evt) {
      $('html, body').stop(true).animate({
        scrollTop: Math.max(0, $(evt.target).offset().top - 100)
      }, 250);
    },

    /**
    * Event callback for Theme Editor `section:unload` event
    */
    onUnload: function() {
      $(window).off(this.namespace);
      this.$childSections.each(function(){
        var event = new CustomEvent('shopify:section:unload', {
          bubbles: true,
          cancelable: true,
          detail: {
            sectionId: $(this).data('section-id')
          }
        });
        $(this)[0].dispatchEvent(event);
      });
    }
  });

  return PageStoryTemplate;
})();

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * For the cart page
 *
 * @namespace cart-template
 */

theme.CartTemplate = (function() {

  var selectors = {
    termsCheckbox: '#terms'
  };

  /**
   * CartTemplate section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function CartTemplate(container) {
    this.$container = $(container);
    this.namespace = '.cartTemplate';

    // show/hide shipping estimates
    this.$container.on('click' + this.namespace, '.js-shipping-calculator-trigger', function(){
      var $this = $(this);
      var $parent = $this.parents('.shipping-calculator-container');
      $parent.toggleClass('calculator-open');
      if($parent.hasClass('calculator-open')){
        $this.children().html(theme.strings.cart_shipping_calculator_hide_calculator);
        $parent.children('.shipping-calculator').slideDown(250);
      } else {
        $this.children().html(theme.strings.cart_shipping_calculator_title);
        $parent.children('.shipping-calculator').slideUp(250);
      }
    });

    // show/hide the cart notes
    this.$container.on('click' + this.namespace, '.js-cart-notes-trigger', function(){
      var $this = $(this);
      var $parent = $this.parent('.cart-notes-container');
      $parent.toggleClass('notes-open');
      if($parent.hasClass('notes-open')){
        $this.children().html(theme.strings.cart_general_hide_note);
        $parent.children('.cart-notes').slideDown(250);
      } else {
        $this.children().html(theme.strings.cart_general_show_note);
        $parent.children('.cart-notes').slideUp(250);
      }
    });

    // terms and conditions checkbox
    if($(selectors.termsCheckbox, container).length > 0) {
      $(document).on('click' + this.namespace, '[name="checkout"], a[href="/checkout"]', function() {
        if($(selectors.termsCheckbox + ':checked').length == 0) {
          alert(theme.strings.cartTermsNotChecked);
          return false;
        }
      });
    }

    // quantity adjustment
    if(this.$container.data('ajax-update')) {
      var updateCartFunction = this.updateCart.bind(this);
      this.$container.on('keyup' + this.namespace + ' change' + this.namespace, '.quantity-adjuster__input', function(){
        if($(this).data('initial-value') && $(this).data('initial-value') == $(this).val()){
          return;
        }
        if($(this).val().length == 0 || $(this).val() == '0') {
          return;
        }
        var inputId = $(this).attr('id');
        updateCartFunction({
          line: $(this).data('line'),
          quantity: $(this).val()
        }, function(){
          // set focus inside input that changed
          console.log('Focussing on: '+'#' + inputId);
          $('#' + inputId).focus();
        });
        $(this).data('previousValue', $(this).val());
      });

      this.$container.on('click' + this.namespace, '.quantity-adjuster__button--down, .quantity-adjuster__button--up', function(e){
        var $input = $(this).closest('.quantity-adjuster').find('.quantity-adjuster__input');
        if($(this).hasClass('quantity-adjuster__button--down')) {
          $input.val(parseInt($input.val()) - 1).trigger('change');
        } else {
          $input.val(parseInt($input.val()) + 1).trigger('change');
        }
        return false;
      });
    }

    // note: adds event to window
    theme.initProductTitleAlignmentWatcher(this.$container, this.namespace);
  }

  CartTemplate.prototype = $.extend({}, CartTemplate.prototype, {
    /**
     * Function for changing the cart and updating the page
     */
    updateCart: function(params, successCallback){
      var _ = this;
      if(_.cartXhr) {
        _.cartXhr.abort();
      }
      if(_.cartRefreshXhr) {
        _.cartRefreshXhr.abort();
      }
      _.cartXhr = $.ajax({
        type: 'POST',
        url: theme.routes.cart_change_url + '.js',
        data: params,
        dataType: 'json',
        success: function(data){
          if(_.cartRefreshXhr) {
            _.cartRefreshXhr.abort();
          }

          // fetch new html for the page
          _.cartRefreshXhr = $.ajax({
            type: 'GET',
            url: theme.routes.cart_url + '?view=ajax',
            success: function(data){
              var toReplace = ['.cart-items', '.cart-subtotal-and-discounts'];
              var $newDom = $('<div>' + data + '</div>');
              $newDom.find('.fade-in').removeClass('fade-in');

              for(var i = 0; i < toReplace.length; i++) {
                $('[data-section-type="cart-template"] ' + toReplace[i]).html(
                  $newDom.find(toReplace[i]).html()
                );
              }

              successCallback();
            },
            error: function(data){
              if(data.statusText != 'abort') {
                console.log('Error refreshing page');
                console.log(data);
              }
            },
            complete: function(){
              _.cartRefreshXhr = null;
            }
          });
        },
        error: function(data){
          console.log('Error processing update');
          console.log(data);
        }
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      $(window).off(this.namespace);
      $(document).off(this.namespace);
      this.$container.off(this.namespace);
    }
  });

  return CartTemplate;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink(theme.routes.account_addresses_url + '/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


theme.namespaceFromSection = function(container) {
  return ['.', $(container).data('section-type'), $(container).data('section-id')].join('');
}

theme.openPageContentInLightbox = function(url) {
  $.get(url, function(data){
    var $content = $('#MainContent', $.parseHTML('<div>'+data+'</div>'));
    $.colorbox({
      transition: 'fade',
      html: '<div class="lightbox-content">' + $content.html() + '</div>',
      onOpen: theme.colorboxFadeTransOnOpen,
      onComplete: function(){
        theme.colorboxFadeTransOnComplete();
        // check any new inputs
        $('#cboxContent .input-wrapper input').trigger('inputstateEmpty');
      }
    });
  });
};

theme.styleVariantSelectors = function($els, data){
  $els.each(function(){
    if(typeof $(this).data('listed') != 'undefined') {
      // list options out, bound to the original dropdown
      $(this).clickyBoxes();

      // change swatch label on hover
      var $label = $(this).closest('.selector-wrapper').find('.variant-option-title');
      if($label.length) {
        $label.data('default-content', $label.html());
        $(this).siblings('.clickyboxes').on('change', function() {
          $label.data('default-content', $(this).find('a.active').data('value'));
        }).on('mouseenter', 'a', function(){
          $label.html($(this).data('value'));
        }).on('mouseleave', 'a', function(){
          $label.html($label.data('default-content'));
        });
      }

      if(data.options.length == 1) {
        for(var i=0; i<data.variants.length; i++) {
          var variant = data.variants[i];
          if(!variant.available) {
            $(this).siblings('.clickyboxes').find('a').filter(function(){
              return $(this).data('value') == variant.option1
            }).addClass('unavailable');
          }
        }
      }
    } else {
      // apply select2 to dropdown
      var config = {};
      theme.select2.init($(this), config);
    }
  });
}

theme.select2 = {
  init: function($els, config){
    var standardSelectOptions = {
      minimumResultsForSearch: Infinity
    };
    var swatchSelectOptions = {
      minimumResultsForSearch: Infinity,
      templateResult: theme.select2.swatchSelect2OptionTemplate,
      templateSelection: theme.select2.swatchSelect2OptionTemplate
    };
    if(typeof config !== 'undefined') {
      standardSelectOptions = $.extend(standardSelectOptions, config);
      swatchSelectOptions = $.extend(swatchSelectOptions, config);
    }
    $els.each(function(){
      $(this).select2($(this).data('colour-swatch') ? swatchSelectOptions : standardSelectOptions);
    });
  },
  swatchSelect2OptionTemplate: function(state) {
    if (state.id) {
      var colourKey = removeDiacritics(state.id).toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/-*$/, '');
      return $([
        '<div class="swatch-option">',
        '<span class="swatch-option__nugget bg-', colourKey, '"></span>',
        '<span class="swatch-option__label">', state.text, '</span>',
        '</div>'
      ].join(''));
    } else {
      return $([
        '<div class="swatch-option swatch-option--all">',
        '<span class="swatch-option__label">', state.text, '</span>',
        '</div>'
      ].join(''));
    }
  }
};

theme.colorboxFadeTransOnOpen = function(){
  $('#colorbox').addClass('colorbox--hide');
};

theme.colorboxFadeTransOnComplete = function(){
  setTimeout(function(){
    $('#colorbox').addClass('colorbox--enable-trans');
    setTimeout(function(){
      $('#colorbox').removeClass('colorbox--hide');
      setTimeout(function(){
        $('#colorbox').removeClass('colorbox--enable-trans');
      }, 300);
    }, 20);
  }, 10);
};

theme.productGallerySlideshowTabFix = function(slides, current) {
  // tabindex everything to prevent tabbing into hidden slides
  $(slides[current]).find('a, input, button, select, iframe, video, model-viewer, [tabindex]').each(function(){
    if(typeof $(this).data('theme-slideshow-original-tabindex') !== 'undefined') {
      if($(this).data('theme-slideshow-original-tabindex') === false) {
        $(this).removeAttr('tabindex');
      } else {
        $(this).attr('tabindex', $(this).data('theme-slideshow-original-tabindex'));
      }
    } else {
      $(this).removeAttr('tabindex');
    }
  });
  $(slides).not(slides[current]).find('a, input, button, select, iframe, video, model-viewer, [tabindex]').each(function(){
    if(typeof $(this).data('theme-slideshow-original-tabindex') === 'undefined') {
      $(this).data('theme-slideshow-original-tabindex',
        typeof $(this).attr('tabindex') !== 'undefined'
        ? $(this).attr('tabindex')
        : false
      );
      $(this).attr('tabindex', '-1');
    }
  });
};

try {
  theme.shopifyFeatures = JSON.parse(document.documentElement.querySelector('#shopify-features').textContent);
} catch (e) {
  theme.shopifyFeatures = {};
}

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('sidebar', theme.Sidebar);
  sections.register('product', theme.Product);
  sections.register('header', theme.Header);
  sections.register('footer', theme.Footer);
  sections.register('banner', theme.Banner);
  sections.register('featured-collection', theme.FeaturedCollection);
  sections.register('mini-collection-list', theme.MiniCollectionList);
  sections.register('map', theme.Map);
  sections.register('video', theme.Video);
  sections.register('logo-list', theme.LogoList);
  sections.register('collection-template', theme.CollectionTemplate);
  sections.register('page-story-template', theme.PageStoryTemplate);
  sections.register('cart-template', theme.CartTemplate);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Enable focus style when using tab
  $(document).on('keyup.themeTabCheck', function(evt) {
    if(evt.keyCode === 9) {
      $('body').addClass('tab-used');
      $(document).off('keyup.themeTabCheck');
    }
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  $('.footer-nav__accordion').on('click', '.js-footer-accordion-trigger', function(){
    $(this).siblings('.footer-nav__submenu').slideToggle(250);
    $(this).toggleClass('accordion-open');
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Quantity input wrapper
  $(document).on('change', '.quantity-proxy', function(){
    var value = $(this).val();
    var $input = $(this).siblings('[name="quantity"]');
    if(value == '10+') {
      $input.val('10').closest('.quantity-wrapper').addClass('hide-proxy');
      setTimeout(function(){
        $input.select().focus();
      }, 10);
    } else {
      $input.val(value);
    }
  });
});

theme.initProductTitleAlignmentWatcher = function($container, namespace){
  var $productGrids = $('.product-grid', $container);
  if($productGrids.length) {
    theme.alignProductImageTitles.bind($productGrids)();
    $(window).on('debouncedresize' + namespace, theme.alignProductImageTitles.bind($productGrids));
  }
};

theme.alignProductImageTitles = function(){
  $(this).each(function(){
    var tallest = 0;
    $('.product-block__primary-image', this).each(function(){
      var h = $(this).height();
      if(h > tallest) {
        tallest = h;
      }
    });
    $('.product-block__image', this).css('min-height', tallest);
  });
};

})(theme.jQuery);

